import { render, staticRenderFns } from "./MRSModal.vue?vue&type=template&id=1c9c1b8b"
import script from "./MRSModal.vue?vue&type=script&lang=js"
export * from "./MRSModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports